// The front page (a coming-soon graphic until launch) and the three doors: clients (/client, built
// for phones), loan officers (/lo, built for computers) and the owner (/owner). Each door is a
// placeholder until sign-in arrives.

import { Link, Route, Routes } from 'react-router-dom';
import { PRODUCT } from './config';
import { ClientHome } from './client/ClientHome';
import { LoanOfficerHome } from './lo/LoanOfficerHome';
import { OwnerHome } from './owner/OwnerHome';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<ComingSoonLanding />} />
      <Route path="/client/*" element={<ClientHome />} />
      <Route path="/lo/*" element={<LoanOfficerHome />} />
      <Route path="/owner/*" element={<OwnerHome />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

// The whole page is the graphic. On a computer (or a phone turned sideways) it's shown whole. A
// phone held upright would shrink it to a strip, so there the page fills the screen with the part
// of the photo around the keys and writes the graphic's words over it.
function ComingSoonLanding() {
  return (
    <main className="landing">
      <picture>
        <source media="(orientation: portrait)" srcSet="/coming-soon-phone.jpg" width={520} height={1116} />
        <img
          src="/coming-soon-2000.jpg"
          srcSet="/coming-soon-800.jpg 800w, /coming-soon-1200.jpg 1200w, /coming-soon-2000.jpg 2000w"
          sizes="100vw"
          width={2000}
          height={1116}
          alt={`A person holding a ring of house keys walks up to a front door. Coming soon: ${PRODUCT.domain}`}
        />
      </picture>
      {/* Hidden while the graphic shows its own words; shown over the phone crop */}
      <h1 className="landing-words">
        <span className="landing-soon">Coming Soon…</span>
        <span className="landing-domain">{PRODUCT.domain}</span>
      </h1>
    </main>
  );
}

function NotFound() {
  return (
    <main className="page">
      <h1>Page not found</h1>
      <p><Link to="/">Back to {PRODUCT.name}</Link></p>
    </main>
  );
}
